import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getWrapperClasses = ({
  focused,
  disabled,
  dsf_error,
  dsf_success,
  dsf_size
}) => {
  const classes = [
    "relative",
    "rounded-sm",
    "border",
    "flex",
    "flex-row",
    "items-center",
    "px-12"
  ];
  classes.push(dsf_size === "small" ? "h-32" : "h-40");
  classes.push(disabled ? "bg-neutral-50" : "bg-neutral-0");
  if (!disabled) {
    classes.push("active:bg-secondary-50");
  }
  if (dsf_error && !disabled) {
    classes.push("border-error-300");
    if (focused) {
      classes.push("shadow-focus-danger-md");
    }
  } else if (dsf_success && !disabled) {
    classes.push("border-success-300");
    if (focused) {
      classes.push("shadow-focus-success-md");
    }
  } else {
    if (focused) {
      classes.push("border-secondary-300", "shadow-focus-secondary-md");
    } else {
      classes.push("border-neutral-100");
    }
  }
  return concatClasses(classes);
};
const getInputClasses = ({
  dsf_icon_right,
  dsf_icon_left,
  hasContent,
  dsf_size,
  dsf_hide_native_elements
}) => {
  const classes = [
    "w-full",
    "text-neutral-700",
    "disabled:text-neutral-400",
    "placeholder:text-neutral-300",
    "appearance-none",
    "outline-none",
    "bg-transparent"
  ];
  if (dsf_hide_native_elements) {
    classes.push("hide-native-elements");
  }
  if (dsf_size === "small") {
    classes.push("placeholder:dsf-text-xs", "dsf-text-xs");
  } else {
    classes.push("placeholder:dsf-text-s", "dsf-text-s");
  }
  if (dsf_icon_right || hasContent) {
    classes.push("pr-12");
  }
  if (dsf_icon_left) {
    classes.push("pl-12");
  }
  return concatClasses(classes);
};
const getIconClasses = ({
  disabled,
  hasContent,
  dsf_icon_right,
  dsf_icon_right_clickable,
  dsf_icon_left_clickable,
  dsf_icon_right_class,
  dsf_error,
  dsf_success
}, right = false) => {
  const classes = ["w-16", "h-16"];
  if (dsf_error) {
    classes.push("text-error-300");
  } else if (dsf_success) {
    classes.push("text-success-300");
  } else {
    classes.push(disabled ? "text-neutral-400" : "text-neutral-700");
  }
  if (!right && dsf_icon_left_clickable || right && dsf_icon_right_clickable) {
    classes.push("cursor-pointer");
  }
  if (right && hasContent && dsf_icon_right) {
    classes.push("pl-12");
  }
  if (right && dsf_icon_right_class) {
    classes.push(dsf_icon_right_class);
  }
  return concatClasses(classes);
};
const getMessageClasses = ({ disabled, dsf_success, dsf_error, dsf_size }) => {
  const classes = ["dsf-text-xxs"];
  classes.push(dsf_size === "small" ? "mt-2" : "mt-4");
  if (dsf_error) {
    classes.push("text-error-300");
  } else if (dsf_success) {
    classes.push("text-success-300");
  } else if (disabled) {
    classes.push("text-neutral-400");
  } else {
    classes.push("text-neutral-700");
  }
  return concatClasses(classes);
};
const getLabelTextClasses = ({ dsf_size }) => {
  const classes = ["text-neutral-700"];
  classes.push(dsf_size === "small" ? "dsf-text-xxs" : "dsf-text-xs");
  classes.push(dsf_size === "small" ? "mb-2" : "mb-4");
  return concatClasses(classes);
};
export {
  getIconClasses,
  getInputClasses,
  getLabelTextClasses,
  getMessageClasses,
  getWrapperClasses
};
